import React from "react";
import "../style/Loader.css";

// Colored Loader
export function ButtonLoader1() {
  return (
    <>
      <span class="loader-1"></span>
    </>
  );
}

export function ButtonLoader4() {
  return (
    <>
      <span class="loader"></span>
    </>
  );
}

// White Loader
export function ButtonLoader2() {
  return (
    <>
      <span class="loader-2"></span>
    </>
  );
}

export function ButtonLoader3() {
  return (
    <>
      <span class="loader-3"></span>
    </>
  );
}
